import { Box, Card, CardActions, CardContent, Link, Typography } from '@mui/material';
import { withNavbar } from '../../app/layout/HOC';
import { router } from '../../app/router/Routes';

function NotFound() {
  return (
    <Box>
      <Card sx={{ minWidth: 275, maxWidth: 400, m: '0 auto', height: 200, mt: 12.5 }}>
        <CardContent>
          <Typography sx={{ fontSize: 14 }} color="textSecondary" gutterBottom>
            Oops - we've looked everywhere and could not find this.
          </Typography>
        </CardContent>
        <CardActions>
          <Link href="/" onClick={() => router.navigate('/')}>
            Go to home
          </Link>
        </CardActions>
      </Card>
    </Box>
  );
}

const NotFoundPage = withNavbar(NotFound);

export default NotFoundPage;